import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1A1B1F",
  "fill-rule": "evenodd",
  d: "M10.757 8.595h28.54V29.35h-3.46V12.054h-25.08zm-2.595 3.459H2.108V38h33.73v-6.054h6.054V6H8.162zm22.351 20.757h-6.919v-3h6.92zm2.73-18.162H4.703v4.783h28.54zm0 20.756V22.432H4.703v12.973z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }